var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isClubActivityPage)?_c('div',{staticClass:"w-3/12  pr-0 sm:pl-1 sm:pr-1 pt-0 pb-2 flex-col hidden sm:inline-flex relative h-full"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }